{
  "name": "@shopliftr/smart",
  "description": "Shopliftr SMART Designer Web App",
  "version": "19.28.0"
}
